import { useCallback, useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from 'js/store/hooks';
import { showCallout } from 'js/actionCreators/uiActions';

function useLatest<T>(value: T) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useIsOnlineCallback<T extends (...args: any[]) => any>(callback: T) {
  const latestFn = useLatest(callback);
  const dispatch = useAppDispatch();
  const isOnline = useAppSelector(state => state.network.isOnline);
  const wrappedCallback = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args: any[]) => {
      if (isOnline) {
        latestFn.current(...args);
      } else {
        dispatch(
          showCallout({
            title: 'You are currently offline',
            details: 'You must be online to perform this action.',
            isError: true,
            icon: 'offline'
          })
        );
      }
    },
    [isOnline, latestFn, dispatch]
  );

  return wrappedCallback;
}
